import React, { useState, useRef, useEffect } from "react";
import "./CreditsDropDown.css";
import { MoneyWithWings } from "../../svgs/MoneyWithWings";
import { getCreditBalance, getCreditTransactions } from "../../services/iqApiV2";
import IOSSpinner from "../HtmlElements/IOSSpinner";

export default function CreditsDropDown({ user }) {
  const [isLoading,setIsLoading]=useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
    const [availableCredits,setAvailableCredits]=useState({currBalance:0,totalBalance:0});
  useEffect(() => {
  async function  fetchData (){
    setIsLoading(true)
    const resp =  await getCreditBalance(user?.id);
    const totalResp =await getCreditTransactions(user?.id)
    const total = (totalResp ?? [])
    .filter(item => item?.type === "credit")
    .reduce((sum, item) => sum + (item?.credits ?? 0), 0);

    setAvailableCredits( {currBalance:resp,totalBalance:total});
    setIsLoading(false)
  }
      
  fetchData();
  }, [user?.id,isOpen])
  

  const percent = Math.min((availableCredits?.currBalance / availableCredits?.totalBalance) * 100, 100);

  const formatCredits = (num) => {
    if (num >= 1000) return (num / 1000).toFixed(1).replace(".0", "") + "k";
    return num;
  };

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen((p) => !p);
  };

  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="credits-dd-wrapper" ref={ref}>
      <button className="credits-btn" onClick={toggle}>
        <MoneyWithWings /> Credits
      </button>

      <div className={`credits-dd-menu ${isOpen ? "credits-show" : ""}`}>
        <div className="credits-header-row">
          <div className="credits-username">{user?.firstname?.trim()}'s credits</div>
          <div className="credits-numbers">
            {isLoading ? <IOSSpinner/> :availableCredits?.currBalance} available / {availableCredits?.totalBalance}
          </div>
          <div className="credits-progress-container-inline">
            <div
              className="credits-progress-bar"
              style={{ width: `${percent}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}
